import angular from 'angular';
import tableSearchComponent from './tableSearch.component';

let tableSearchModule = angular.module('tableSearch', []).component('tableSearch', tableSearchComponent);

export default tableSearchModule;



// WEBPACK FOOTER //
// ./app/components/tableSearch/tableSearch.js